import { type DropdownListItem } from '@verantos-dev/shared-components';
import {
  type ActiveCohortBuilderItemLegacy,
  type CohortBuilderDefinitionLegacy,
  DerivedEventTypeLegacy,
  SimpleEventTypeLegacy,
} from '@verantos-dev/types-cohorts';

export const getCurrentCohortEventNames = (
  activeCohortBuilderItem: ActiveCohortBuilderItemLegacy | undefined,
  currentCohortDefinition: CohortBuilderDefinitionLegacy | undefined
): DropdownListItem[] => {
  const eventNames: DropdownListItem[] = [];

  currentCohortDefinition?.simpleEvents.forEach((event) => {
    if (event.name && event.type && event.id !== activeCohortBuilderItem?.id) {
      if (event.type === SimpleEventTypeLegacy.CONDITION_OCCURRENCE) {
        eventNames.push({
          value: `CONDITION_OCCURRENCE::"${event.name}"`,
          displayValue: event.name,
        });
      }
      if (event.type === SimpleEventTypeLegacy.DRUG_EXPOSURE) {
        eventNames.push({
          value: `DRUG_EXPOSURE::"${event.name}"`,
          displayValue: event.name,
        });
      }
      if (event.type === SimpleEventTypeLegacy.MEASUREMENT) {
        eventNames.push({
          value: `MEASUREMENT::"${event.name}"`,
          displayValue: event.name,
        });
      }
      if (event.type === SimpleEventTypeLegacy.OBSERVATION) {
        eventNames.push({
          value: `OBSERVATION::"${event.name}"`,
          displayValue: event.name,
        });
      }
      if (event.type === SimpleEventTypeLegacy.PROCEDURE_OCCURRENCE) {
        eventNames.push({
          value: `PROCEDURE_OCCURRENCE::"${event.name}"`,
          displayValue: event.name,
        });
      }
      if (event.type === SimpleEventTypeLegacy.VISIT_OCCURRENCE) {
        eventNames.push({
          value: `VISIT_OCCURRENCE::"${event.name}"`,
          displayValue: event.name,
        });
      }
    }
  });
  currentCohortDefinition?.derivedEvents.forEach((event) => {
    if (event.name && event.type && event.id !== activeCohortBuilderItem?.id) {
      if (event.type === DerivedEventTypeLegacy.MERGED) {
        eventNames.push({
          value: `MERGED_EVENT::"${event.name}"`,
          displayValue: event.name,
        });
      }
      if (event.type === DerivedEventTypeLegacy.SEQUENCE) {
        eventNames.push({
          value: `SEQUENCE_EVENT::"${event.name}"`,
          displayValue: event.name,
        });
      }
      if (event.type === DerivedEventTypeLegacy.INSTANCE) {
        eventNames.push({
          value: `INSTANCE_EVENT::"${event.name}"`,
          displayValue: event.name,
        });
      }
    }
  });

  return eventNames;
};
